import moment from "moment-jalaali";
// const baseUrl = 'http://192.168.248.113:8080'
// const baseUrl = 'https://payment.iranair.com'
// const baseUrl = 'https://payment.homares.ir'
const baseUrl = 'https://payment.tahagasht.com'


const urls = {
  baseUrl,
  login: baseUrl + '/api/auth/login',
  refreshToken: baseUrl + '/api/auth/refresh',
  transactionInquiry: (transactionId) => `${baseUrl}/api/public/txnInquiry/${transactionId}`,
  transactionConfirm: transactionId => `${baseUrl}/api/public/txnPayment/${transactionId}`,
  transactionVerify: (transactionId, rrn) => `${baseUrl}/api/public/txnVerify/${transactionId}/${rrn}`,
  transactionBlock: transactionId => `${baseUrl}/api/v1/transaction/block/${transactionId}`,
  transactionUnblock: transactionId => `${baseUrl}/api/v1/transaction/unblock/${transactionId}`,
  transactionHistory: transactionId => `${baseUrl}/api/v1/transaction/history/${transactionId}`,
  transactionConfirmCash: transactionId => `${baseUrl}/api/v1/transaction/confirmCashPayment/${transactionId}`,
  transactionItinerary: `${baseUrl}/api/v1/transaction/itinerary`,
  transactionExport: `${baseUrl}/api/v1/transaction/csv`,
  paymentList: baseUrl + '/api/v1/transaction/list',
  linkDetail: id => baseUrl + `/api/v1/transaction/detail/${id}`,
  accessibleProduct: baseUrl + '/api/v1/product/list',
  createTransaction: baseUrl + '/api/v1/transaction/add',
  visiblePaymentGateway: baseUrl + '/api/v1/account/list',
  userInformation: baseUrl + '/api/v1/user/info',
  notify: baseUrl + '/api/v1/transaction/notify',
  updateLink: (transactionId) => `${baseUrl}/api/v1/transaction/update/${transactionId}`,
  currencies: baseUrl + '/api/v1/currency/list',
  searchCurrency: (code) => `${baseUrl}/api/v1/currency/get/byCode/${code}`,
  searchUser: baseUrl + '/api/v1/user/accessibleList',
  searchOffice: baseUrl + '/api/v1/office/accessibleList',
  officeList: baseUrl + '/api/v1/office/list',
  createOffice: baseUrl + '/api/v1/office/add',
  searchCity: (code) => `${baseUrl}/api/v1/city/get/byCode/${code}`,
  accountsList: baseUrl + '/api/v1/account/listAll',
  updateOffice: (officeId) => `${baseUrl}/api/v1/office/update/${officeId}`,
  officeDetail: (officeId) => `${baseUrl}/api/v1/office/detail/${officeId}`,
  UserList: baseUrl + '/api/v1/user/list',
  userDetail: (userId) => `${baseUrl}/api/v1/user/detail/${userId}`,
  roleList: baseUrl + '/api/v1/role/list',
  productList: baseUrl + '/api/v1/product/listAll',
  searchOfficeByCode: (code) => `${baseUrl}/api/v1/office/get/byCode/${code}`,
  createUser: baseUrl + '/api/v1/user/add',
  updateUser: (userId) => `${baseUrl}/api/v1/user/update/${userId}`,
  privilegeList: baseUrl + '/api/v1/privilege/list',
  createRole: baseUrl + `/api/v1/role/add`,
  roleDetail: (roleId) => `${baseUrl}/api/v1/role/detail/${roleId}`,
  updateRole: (roleId) => `${baseUrl}/api/v1/role/update/${roleId}`,
  changePassword: baseUrl + '/api/v1/user/chpass',
  getDetailByPNR: (reference) => `${baseUrl}/api/v1/transaction/autoAmount/${reference}`,
  publishTransaction: (id) => `${baseUrl}/api/v1/transaction/publish/${id}`,
  inquiryUpdate: (id) => `${baseUrl}/api/v1/transaction/inquiryUpdate/${id}`,
  excessbaggagePnr: (pnr) => `${baseUrl}/api/v1/excessbaggage/booking/${pnr}`,
  segmentRate: (segment) => `${baseUrl}/api/v1/excessbaggage/excessRate/${segment}`,
  excessbaggageCalculator: baseUrl + '/api/v1/excessbaggage/calculate',
  excessbaggageReceipt: baseUrl + '/api/v1/excessbaggage/receipt',
  ibanInquiry: (id) => `${baseUrl}/api/v1/transaction/inquiryIban/${id}`,
  inquiryItinerary: (id) => `${baseUrl}/api/v1/transaction/inquiryItinerary/${id}`,
  confirmIban: (id) => `${baseUrl}/api/v1/transaction/inquiryIban/${id}`

}
const services = {
  Ticket: 'صدور بلیت',
  Baggage: 'صدور اضافه بار',
  Freight: 'صدور بارنامه',
  Handling: 'هزینه خدمات هندلینگ',
  Engineering: 'هزینه خدمات فنی و مهندسی',
  Catering: 'هزینه خدمات کترینگ',
  Rent: 'هزینه اجاره',
  Training: 'هزینه خدمات آموزشی',
  Others: 'هزینه سایر',
  Security: 'هزینه خدمات حراستی',
  Amadeus: 'صورتحساب آمادئوس ایران',
  Flight: 'بلیط پرواز',
  Hotel: 'رزرو هتل',
  FlightHotel: 'پرواز و هتل',
  Tour:'تور مسافرتی'
}
const e2p = s => s.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
const g2j = d => {
  d = new Date(d)
  let date = new Intl.DateTimeFormat('fa-IR').format(d);
  let timetext = d.toTimeString().split(' ')[0]
  return `${date} ${e2p(timetext)}`
}
const dateFormat = (ds) => {
  const d = new Date(ds)
  const datestring = `${d.getFullYear().toString()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  return datestring
}

const getPrevAlphabetDate = (date, day) => {
  if (!date) return "";
  return moment(date)
    .add(day * -1, "day")
    .format("ddd D MMM");
};

const getAlphabetDate = (date, locale = 'fa', format = "dddd jD jMMMM") => {
  moment.loadPersian({ dialect: 'persian-modern' })
  if (!date) return "";
  return moment(date).locale(locale).format(format);
};

const getTime = (date, utcOffset = 210) => {
  if (!date) return "";
  return moment(date).utcOffset(utcOffset).format("HH:mm");

};


export default {
  urls,
  services,
  e2p,
  g2j,
  dateFormat,
  baseUrl,
  getPrevAlphabetDate,
  getTime,
  getAlphabetDate
}
